/**
 * Class strings for the chips staged above the chat composer (editing, reply,
 * staged moment) — one definition so a new chip matches staging's look.
 */

/** Accent-bordered chip body shared by the editing, reply and moment chips. */
export const COMPOSER_CHIP_CLASS = 'mb-2 flex items-start gap-2 rounded-[6px] border-l-2 border-(--brand-500) bg-muted/60 px-2.5 py-2';

/** Chip header line: small icon + purple label. */
export const COMPOSER_CHIP_TITLE_CLASS = 'flex items-center gap-1 text-[11px] font-semibold text-(--brand-600)';

/** The chip's × — size-6 (24px) for WCAG 2.5.8 target size; dimmed while a send holds what it would remove. */
export const COMPOSER_CHIP_DISMISS_CLASS =
  'flex size-6 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:bg-accent disabled:pointer-events-none disabled:opacity-50';
